module.exports = __webpack_public_path__ + "img/cryopreservation-horizontal-plane-micro-sperm.968bf73c.png";